import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
/**
 * Auf-/Zuklappbarer Bereich (MUI-`Collapse`-Ersatz) via CSS-Grid-Hoehe — ohne
 * Messung, `prefers-reduced-motion`-vertraeglich (reine Hoehen-Transition).
 */
export const Collapse = forwardRef(function Collapse({ in: open = false, style, children, ...rest }, ref) {
    return (_jsx("div", { ref: ref, "aria-hidden": !open, style: { display: 'grid', gridTemplateRows: open ? '1fr' : '0fr', transition: 'grid-template-rows 200ms ease', ...style }, ...rest, children: _jsx("div", { style: { overflow: 'hidden' }, children: children }) }));
});
